<template>
<div class="row card-fill" :class="`card-${cardStyle}`">
  <div class="col-sm-12"
       :class="`col-md-${columns}`"
        v-for="(item, k) in list"
        :key="k">
    <card class="item" :style="`aspect-ratio: ${item.ratio ? item.ratio : '1'}`">
      <template slot="back">
        <div class="panel-back">
          <a :href="item.link" target="_blank">
            <div class="flip">
              <div class="panel-text text-center">{{ item.text }}</div>
            </div>
            <span class="banner-back">{{ item.action }}</span>
           </a>
        </div>
      </template>
      <template slot="front">
        <div class="panel-front">
          <figcaption class="banner-front">{{ item.type }}</figcaption>
          <img :src="require(`@/assets/img/${item.src}`)"
                class="img-responsive">
        </div>
      </template>
    </card>
  </div>
</div>
</template>

<script>
import card from '@/components/cards/card'

export default {
  name: 'cardFill',

  props: {
    cardStyle: {
      type: String,
      required: true
    },

    list: {
      type: Array,
      required: true
    }
  },

  computed: {
    columns: function () {
      const l = this.list.length
      if (l === 1) {
        return 12
      } else if (l === 2 || l === 4) {
        return 6
      }
      return 4
    }
  },

  components: {
    card
  }
}
</script>
<style lang="less" scoped>
@import '~variables';
@import '~lily';

.card-fill {
  margin: auto;
}

.panel-front, .panel-back {
  position: relative;
  height: 100%;
}

.banner-front,
.banner-back {
  bottom: 8%;
  width: 100%;
  left: 0%;
  position: absolute;
  text-align: center;
  font-size: 150%;
}

.item {
  margin: auto;
  max-width: 36rem;
  width: 90%;
}

.panel-back,
.panel-front,
.img-responsive {
  width: 100%;
  height: 100%;
  border-radius: 1rem;
}

.flip {
  border: solid 2px;
  border-radius: 1rem;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.95;
}

.panel-text {
  padding: 1.5rem;
  padding-top: 3rem;
  font-size: 120%;
}

.panel-back a {
  text-decoration: none;
}

.item {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
